import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import MuiAlert from "@material-ui/lab/Alert";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Snackbar,
} from "@material-ui/core";
import { validateInput, setLoginError } from "../../utils/Functions/functions";
import UserInput from "../UserInput/UserInput";
import axios from "../../utils/Axios/axiosProxy";
import userInputStyle from "../../components/UserInput/UserInput.module.scss";
import i18n from "../../utils/LanguageSelector/i18n";
import "./UserEntryPopup.scss";
import { RequestFormContext } from "../../pages/RequestForm/RequestForm";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function UserEntryPopup({ ...props }) {
  const [open, setOpen] = React.useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [password, setPassword] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [passwordError, setPasswordError] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const requestFormContext = React.useContext(RequestFormContext);

  useEffect(() => {
    setEmail(props.contact.email);
  }, [props.contact.email]);

  const createAccount = () => {
    let data = {
      email: email,
      password: password,
      firstname: props.contact.firstname,
      lastname: props.contact.lastname,
      phone: props.contact.phone,
    };
    axios
      .post("/api/user/register", JSON.stringify(data), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("AXIOS RESPONSE: ", response.statusText);
        props.setAccountCreated(true);
        handleClose();
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data);
        setErrorMessage(
          error.response.data === "email already taken"
            ? i18n.t("general.emailtaken")
            : ""
        );
        setOpenAlert(true);
      })
      .catch((error) => console.log("submitToDB error", error));
  };

  const login = () => {
    let data = { email: email, password: password };
    axios
      .post("/api/user/login", JSON.stringify(data), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("AXIOS RESPONSE: ", response.statusText);
        localStorage.setItem("JWT", response.data.JWT);
        requestFormContext.getUserAccount(response.data.JWT);
        setOpen(false);
        props.handleLogin();
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data);
        setErrorMessage(setLoginError(error.response.data));
        setOpenAlert(true);
      })
      .catch((error) => console.log("submitToDB error", error));
  };

  const handleSubmit = () => {
    if (props.register) {
      createAccount();
    } else login();
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseAlert = () => {
    setOpenAlert(false);
  };
  const handlePassword = (event) => {
    setPassword(event.target.value);
    setPasswordError(validateInput("password", event.target.value).password);
  };
  const handleEmail = (event) => {
    setEmail(event.target.value);
  };
  return (
    <div>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
        style={{ width: "100%" }}
      >
        <Alert onClose={handleClose} severity="error" className="AlertWidth">
          {errorMessage}
        </Alert>
      </Snackbar>
      <Button
        className={
          props.register
            ? "OldLace Large"
            : "OldLaceSquare Login MarginHorizontal"
        }
        onClick={handleClickOpen}
        style={{ marginRight: "16px" }}
      >
        {props.register ? (
          i18n.t("loginpopup.createacc")
        ) : (
          <span>
            {i18n.t("loginpopup.question")}
            <span style={{ textDecoration: "underline" }}>
              {i18n.t("loginpopup.signin")}
            </span>
          </span>
        )}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
        fullWidth={true}
        maxWidth="sm"
      >
        <div>
          <span onClick={handleClose} className="CloseSign">
            X
          </span>
        </div>
        <p className="RegTitle">
          {props.register
            ? i18n.t("loginpopup.createacc")
            : i18n.t("general.signin")}
        </p>
        <DialogContent>
          <UserInput
            name={i18n.t("general.email")}
            id="email"
            className={userInputStyle.RegInput}
            value={email}
            onChange={(event) => {
              handleEmail(event);
            }}
            disabled={props.register ? true : null}
          />
          <UserInput
            name={i18n.t("general.password")}
            className={userInputStyle.RegInput}
            type="password"
            id="password"
            onChange={(event) => {
              handlePassword(event);
            }}
            value={password}
          />
          {props.register ? (
            <div className="FloatRight" style={{ width: "68%" }}>
              <span className="ErrorMessage">{passwordError}</span>
            </div>
          ) : (
            <></>
          )}
        </DialogContent>
        <DialogActions className="FlexCenter">
          <Button
            onClick={handleSubmit}
            className="ToreaBay Medium MarginHorizontal"
          >
            {props.register
              ? i18n.t("loginpopup.createacc")
              : i18n.t("general.signin")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default withTranslation()(UserEntryPopup);
